import get from 'lodash/get';
import { DataStore } from '../stores';
import { DisclaimerType } from '../models/DisclaimerType';
export function getDisclaimers(
    dataStore: DataStore,
    disclaimerTypes: Array<DisclaimerType> = [],
    entityDisclaimers: any
) {
    const disclaimers = disclaimerTypes
        .map(d => {
            if (d.linked) {
                return get(
                    getDisclaimersDictionary(
                        entityDisclaimers,
                        dataStore.culture,
                        dataStore.config.defaultCulture
                    ),
                    d.disclaimerType
                );
            } else {
                return get(dataStore.disclaimersDictionary, d.disclaimerType);
            }
        })
        .filter(d => d !== undefined);

    return disclaimers;
}

function getDisclaimersDictionary(
    disclaimers: any,
    culture: string,
    defaultCulture: string
) {
    const disclaimersDictionary = {};

    for (const d in disclaimers) {
        if (disclaimers[d]) {
            const { disclaimer = '' } =
                disclaimers[d].find(dc => dc.culture === culture) ||
                disclaimers[d].find(dc => dc.culture === defaultCulture) ||
                {};
            disclaimersDictionary[d] = disclaimer;
        }
    }

    return disclaimersDictionary;
}



// WEBPACK FOOTER //
// ./src/utils/disclaimers.ts